import clsx from 'clsx'
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { MilestoneInfo } from './components/milestone-info'
import styles from './milestone-edit.page.module.scss'
import { RouteEnum } from '../../../constants/routes.enum'
import { useFormBuilderStore } from '../../../entities/form-builder/stores/form-builder.store'
import { MilestoneStatus, MilestoneType } from '../../../entities/workflow/constants/workflow.constants'
import { useCreateMilestone } from '../../../entities/workflow/hooks/workflow.hooks'
import { useWorkspaceStore } from '../../../entities/workflow/stores/workspace.store'
import { MilestoneItem } from '../../../entities/workflow/types/workflow.types'
import { FormBuilder, FormBuilderHandle } from '../../shared/form-builder/form-builder'
import { MilestoneEditForm } from '../milestone/types/milestone-types'

export const MilestoneAddPage = () => {
  const builderRef = useRef<FormBuilderHandle>(null)
  const navigate = useNavigate()

  const { mutateAsync: createMilestone } = useCreateMilestone()
  const clearBuilder = useFormBuilderStore((state) => state.clear)
  const { checkedMilestones, setSelectedMilestones } = useWorkspaceStore()

  useEffect(() => {
    return () => {
      clearBuilder()
    }
  }, [])

  const handleMilestoneInfoSave = async (values: MilestoneEditForm) => {
    const milestoneInfo: Partial<MilestoneItem> = {
      ...values,
      checkList: builderRef.current?.getForm() ?? [],
      status: MilestoneStatus.New,
      type: MilestoneType.Milestone,
    } as Partial<MilestoneItem>

    try {
      const milestone = await createMilestone(milestoneInfo)
      checkedMilestones.add(milestone.id)
      setSelectedMilestones(checkedMilestones)
      navigate(RouteEnum.WORKSPACE + '/' + RouteEnum.MILESTONES)
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <div className={clsx(styles.milestoneEdit)}>
      <div className="col-3">
        <MilestoneInfo onSave={handleMilestoneInfoSave} />
      </div>
      <FormBuilder
        ref={builderRef}
        contentWrapClass="col-2"
        previewWrapClass="col-7"
      />
    </div>
  )
}
